import IconButton from '@/features/ui/buttons/components/IconButton'
import PlusIcon from '@/features/ui/icons/components/PlusIcon'
import { FC } from 'react'

interface IncreaseQuantityButtonProps {
    disabled?: boolean
    onPress: () => void
}

const IncreaseQuantityButton: FC<IncreaseQuantityButtonProps> = ({ disabled, onPress }) => {
    return (
        <IconButton
            disabled={disabled}
            type="outline"
            color="secondary"
            size={44}
            onPress={onPress}
            Icon={PlusIcon}
            testID="increase-quantity-button"
        />
    )
}

export default IncreaseQuantityButton
